module.exports = __webpack_public_path__ + "img/LogOut.f4081a74.svg";